import { declareTheme } from "@component-library/themes";

export const useTheme = declareTheme({
  default: {
    container: 'rounded-lg shadow-sm ring-1 ring-inset ring-neutral-250'
  },
  editor: {
    container: 'rounded shadow-lg'
  }
})